import * as types from './types';

const INITIAL_STATE = {};

function _setInterlinkData(state, action) {
    const {
        id,
    } = action.meta;

    return {
        ...state,
        [id]: action.payload,
    };
}

const handlers = {
    [types.SET_INTERLINK_DATA]: _setInterlinkData,
};

function reducer(currentState = INITIAL_STATE, action) {
    if (handlers.hasOwnProperty(action.type)) {
        const handler = handlers[action.type];

        return handler(currentState, action);
    }

    return currentState;
}

export {
    INITIAL_STATE,
};
export default reducer;
